import { NgModule } from '@angular/core';
import { UploadImageModalComponent } from './upload-image-modal.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule, PreloaderModule, CertemyImageCropperModule, FileErrorsPipe } from '@certemy/ui-components';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { MessageBlockModule } from 'components/message-block/message-block.module';

@NgModule({
  imports: [
    FileUploadModule,
    NgbModalModule,
    PreloaderModule,
    CertemyCommonModule,
    CertemyImageCropperModule,
    MessageBlockModule,
  ],
  exports: [UploadImageModalComponent],
  declarations: [UploadImageModalComponent],
  providers: [FileErrorsPipe],
})
export class UploadImageModalModule {}
